import { GlobalDispatch } from 'context';
import { clearSessionToken } from 'shared/utils/session-token';
import { GlobalAction } from 'store/global-actions';
import { Login } from '../../../domain/login';
import { RequestAutentication } from '../proxy/request-autentication';
import { forgetImpersonation } from './impersonation.actions';

const { StartFetching, FinishedFetching } = GlobalAction;

const login = async (dispatch: GlobalDispatch, username: string, password: string): Promise<Login> => {
  const loginResponse = await RequestAutentication.login(username, password);
  forgetImpersonation();
  dispatch({ type: GlobalAction.LoginInfo, payload: loginResponse });
  return loginResponse;
};

const logout = async (dispatch: GlobalDispatch): Promise<{ message: string }> => {
  dispatch({ type: StartFetching });
  try {
    return await RequestAutentication.logout();
  } finally {
    clearSessionToken();
    forgetImpersonation();
    dispatch({ type: FinishedFetching });
    dispatch({ type: GlobalAction.ClearState });
  }
};

const getAccessModuleUser = async (dispatch: GlobalDispatch): Promise<void> => {
  dispatch({ type: StartFetching });
  try {
    const accessUser = await RequestAutentication.getAccessModuleUser();
    dispatch({ type: GlobalAction.AccessUser, payload: accessUser });
  } finally {
    dispatch({ type: FinishedFetching });
  }
};

export const AutenticationApiActions = {
  login,
  logout,
  getAccessModuleUser,
};
